import {
  ArrowLeftRight,
  ChartPie,
  LayoutDashboard,
  type LucideIcon,
  Repeat,
  Settings,
  WalletCards,
} from "lucide-react";

export type NavItem = { label: string; to: string; icon: LucideIcon; end?: boolean };

export const MAIN_NAV: NavItem[] = [
  { label: "Resumen", to: "/", icon: LayoutDashboard, end: true },
  { label: "Transacciones", to: "/transacciones", icon: ArrowLeftRight },
  { label: "Cuentas", to: "/cuentas", icon: WalletCards },
  { label: "Gastos", to: "/gastos", icon: ChartPie },
  { label: "Recurrentes", to: "/recurrentes", icon: Repeat },
];

export const PREFERENCE_NAV: NavItem[] = [{ label: "Ajustes", to: "/ajustes", icon: Settings }];
